import { Component } from '@angular/core';

@Component({
  selector: 'shared-browser-not-supported',
  templateUrl: './browser-not-supported.component.html'
})
export class BrowserNotSupportedComponent {
}
